import React from 'react';
import { Box, BoxProps, Tooltip } from '@chakra-ui/react';

interface ISummaryGroup {
  children: React.ReactNode;
  title?: string;
  tooltip?: React.ReactNode;
  'data-selector'?: string;
  boxProps?: BoxProps;
}

export const SummaryGroup = (props: ISummaryGroup) => {
  const { children, title, tooltip, boxProps, 'data-selector': dataSelector } = props;

  return (
    <Box
      data-selector={dataSelector}
      borderTopWidth={1}
      _first={{ borderTopWidth: 0 }}
      pt={6}
      lineHeight={5}
      {...boxProps}
    >
      {title && (
        <Box fontWeight={'medium'} mb={2}>
          {tooltip ? (
            <Tooltip hasArrow placement="top-start" label={tooltip}>
              {title}
            </Tooltip>
          ) : (
            title
          )}
        </Box>
      )}

      <Box>{children}</Box>
    </Box>
  );
};
